"use strict";

module.exports = [
    { key: "Pacific/Midway", name: "(-11:00) Midway Island" },
    { key: "Pacific/Samoa", name: "(-11:00) Samoa" },
    { key: "Pacific/Honolulu", name: "(-10:00) Hawaii" },
    { key: "US/Alaska", name: "(-09:00) Alaska" },
    { key: "America/Los_Angeles", name: "(-08:00) Pacific Time (US & Canada)" },
    { key: "America/Tijuana", name: "(-08:00) Tijuana" },
    { key: "US/Arizona", name: "(-07:00) Arizona" },
    { key: "America/Chihuahua", name: "(-07:00) Chihuahua" },
    { key: "America/Chihuahua", name: "(-07:00) La Paz" },
    { key: "America/Mazatlan", name: "(-07:00) Mazatlan" },
    { key: "US/Mountain", name: "(-07:00) Mountain Time (US & Canada)" },
    { key: "America/Managua", name: "(-06:00) Central America" },
    { key: "US/Central", name: "(-06:00) Central Time (US & Canada)" },
    { key: "America/Mexico_City", name: "(-06:00) Guadalajara" },
    { key: "America/Mexico_City", name: "(-06:00) Mexico City" },
    { key: "America/Monterrey", name: "(-06:00) Monterrey" },
    { key: "Canada/Saskatchewan", name: "(-06:00) Saskatchewan" },
    { key: "America/Bogota", name: "(-05:00) Bogota" },
    { key: "US/Eastern", name: "(-05:00) Eastern Time (US & Canada)" },
    { key: "US/East-Indiana", name: "(-05:00) Indiana (East)" },
    { key: "America/Lima", name: "(-05:00) Lima" },
    { key: "America/Bogota", name: "(-05:00) Quito" },
    { key: "Canada/Atlantic", name: "(-04:00) Atlantic Time (Canada)" },
    { key: "America/Caracas", name: "(-04:30) Caracas" },
    { key: "America/La_Paz", name: "(-04:00) La Paz" },
    { key: "America/Santiago", name: "(-04:00) Santiago" },
    { key: "Canada/Newfoundland", name: "(-03:30) Newfoundland" },
    { key: "America/Sao_Paulo", name: "(-03:00) Brasilia" },
    { key: "America/Argentina/Buenos_Aires", name: "(-03:00) Buenos Aires" },
    { key: "America/Argentina/Buenos_Aires", name: "(-03:00) Georgetown" },
    { key: "America/Godthab", name: "(-03:00) Greenland" },
    { key: "America/Noronha", name: "(-02:00) Mid-Atlantic" },
    { key: "Atlantic/Azores", name: "(-01:00) Azores" },
    { key: "Atlantic/Cape_Verde", name: "(-01:00) Cape Verde Is." },
    { key: "Africa/Casablanca", name: "(+00:00) Casablanca" },
    { key: "Europe/London", name: "(+00:00) Edinburgh" },
    { key: "Etc/Greenwich", name: "(+00:00) Dublin (Greenwich Mean Time)" },
    { key: "Europe/Lisbon", name: "(+00:00) Lisbon" },
    { key: "Europe/London", name: "(+00:00) London" },
    { key: "Africa/Monrovia", name: "(+00:00) Monrovia" },
    { key: "UTC", name: "(+00:00) UTC" },
    { key: "Europe/Amsterdam", name: "(+01:00) Amsterdam" },
    { key: "Europe/Belgrade", name: "(+01:00) Belgrade" },
    { key: "Europe/Berlin", name: "(+01:00) Berlin" },
    { key: "Europe/Berlin", name: "(+01:00) Bern" },
    { key: "Europe/Bratislava", name: "(+01:00) Bratislava" },
    { key: "Europe/Brussels", name: "(+01:00) Brussels" },
    { key: "Europe/Budapest", name: "(+01:00) Budapest" },
    { key: "Europe/Copenhagen", name: "(+01:00) Copenhagen" },
    { key: "Europe/Ljubljana", name: "(+01:00) Ljubljana" },
    { key: "Europe/Madrid", name: "(+01:00) Madrid" },
    { key: "Europe/Paris", name: "(+01:00) Paris" },
    { key: "Europe/Prague", name: "(+01:00) Prague" },
    { key: "Europe/Rome", name: "(+01:00) Rome" },
    { key: "Europe/Sarajevo", name: "(+01:00) Sarajevo" },
    { key: "Europe/Skopje", name: "(+01:00) Skopje" },
    { key: "Europe/Stockholm", name: "(+01:00) Stockholm" },
    { key: "Europe/Vienna", name: "(+01:00) Vienna" },
    { key: "Europe/Warsaw", name: "(+01:00) Warsaw" },
    { key: "Africa/Lagos", name: "(+01:00) West Central Africa" },
    { key: "Europe/Zagreb", name: "(+01:00) Zagreb" },
    { key: "Europe/Athens", name: "(+02:00) Athens" },
    { key: "Europe/Bucharest", name: "(+02:00) Bucharest" },
    { key: "Africa/Cairo", name: "(+02:00) Cairo" },
    { key: "Africa/Harare", name: "(+02:00) Harare" },
    { key: "Europe/Helsinki", name: "(+02:00) Helsinki" },
    { key: "Europe/Istanbul", name: "(+02:00) Istanbul" },
    { key: "Asia/Jerusalem", name: "(+02:00) Jerusalem" },
    { key: "Europe/Helsinki", name: "(+02:00) Kyiv" },
    { key: "Africa/Johannesburg", name: "(+02:00) Pretoria" },
    { key: "Europe/Riga", name: "(+02:00) Riga" },
    { key: "Europe/Sofia", name: "(+02:00) Sofia" },
    { key: "Europe/Tallinn", name: "(+02:00) Tallinn" },
    { key: "Europe/Vilnius", name: "(+02:00) Vilnius" },
    { key: "Asia/Baghdad", name: "(+03:00) Baghdad" },
    { key: "Asia/Kuwait", name: "(+03:00) Kuwait" },
    { key: "Europe/Minsk", name: "(+03:00) Minsk" },
    { key: "Africa/Nairobi", name: "(+03:00) Nairobi" },
    { key: "Asia/Riyadh", name: "(+03:00) Riyadh" },
    { key: "Europe/Volgograd", name: "(+03:00) Volgograd" },
    { key: "Asia/Tehran", name: "(+03:30) Tehran" },
    { key: "Asia/Muscat", name: "(+04:00) Abu Dhabi" },
    { key: "Asia/Baku", name: "(+04:00) Baku" },
    { key: "Europe/Moscow", name: "(+04:00) Moscow" },
    { key: "Asia/Muscat", name: "(+04:00) Muscat" },
    { key: "Europe/Moscow", name: "(+04:00) St. Petersburg" },
    { key: "Asia/Tbilisi", name: "(+04:00) Tbilisi" },
    { key: "Asia/Yerevan", name: "(+04:00) Yerevan" },
    { key: "Asia/Kabul", name: "(+04:30) Kabul" },
    { key: "Asia/Karachi", name: "(+05:00) Islamabad" },
    { key: "Asia/Karachi", name: "(+05:00) Karachi" },
    { key: "Asia/Tashkent", name: "(+05:00) Tashkent" },
    { key: "Asia/Calcutta", name: "(+05:30) Chennai" },
    { key: "Asia/Kolkata", name: "(+05:30) Kolkata" },
    { key: "Asia/Calcutta", name: "(+05:30) Mumbai" },
    { key: "Asia/Calcutta", name: "(+05:30) New Delhi" },
    { key: "Asia/Calcutta", name: "(+05:30) Sri Jayawardenepura" },
    { key: "Asia/Katmandu", name: "(+05:45) Kathmandu" },
    { key: "Asia/Almaty", name: "(+06:00) Almaty" },
    { key: "Asia/Dhaka", name: "(+06:00) Astana" },
    { key: "Asia/Dhaka", name: "(+06:00) Dhaka" },
    { key: "Asia/Yekaterinburg", name: "(+06:00) Ekaterinburg" },
    { key: "Asia/Rangoon", name: "(+06:30) Rangoon" },
    { key: "Asia/Bangkok", name: "(+07:00) Bangkok" },
    { key: "Asia/Bangkok", name: "(+07:00) Hanoi" },
    { key: "Asia/Jakarta", name: "(+07:00) Jakarta" },
    { key: "Asia/Novosibirsk", name: "(+07:00) Novosibirsk" },
    { key: "Asia/Hong_Kong", name: "(+08:00) Beijing" },
    { key: "Asia/Chongqing", name: "(+08:00) Chongqing" },
    { key: "Asia/Hong_Kong", name: "(+08:00) Hong Kong" },
    { key: "Asia/Krasnoyarsk", name: "(+08:00) Krasnoyarsk" },
    { key: "Asia/Kuala_Lumpur", name: "(+08:00) Kuala Lumpur" },
    { key: "Australia/Perth", name: "(+08:00) Perth" },
    { key: "Asia/Singapore", name: "(+08:00) Singapore" },
    { key: "Asia/Taipei", name: "(+08:00) Taipei" },
    { key: "Asia/Ulan_Bator", name: "(+08:00) Ulaan Bataar" },
    { key: "Asia/Urumqi", name: "(+08:00) Urumqi" },
    { key: "Asia/Irkutsk", name: "(+09:00) Irkutsk" },
    { key: "Asia/Tokyo", name: "(+09:00) Osaka" },
    { key: "Asia/Tokyo", name: "(+09:00) Sapporo" },
    { key: "Asia/Seoul", name: "(+09:00) Seoul" },
    { key: "Asia/Tokyo", name: "(+09:00) Tokyo" },
    { key: "Australia/Adelaide", name: "(+09:30) Adelaide" },
    { key: "Australia/Darwin", name: "(+09:30) Darwin" },
    { key: "Australia/Brisbane", name: "(+10:00) Brisbane" },
    { key: "Australia/Canberra", name: "(+10:00) Canberra" },
    { key: "Pacific/Guam", name: "(+10:00) Guam" },
    { key: "Australia/Hobart", name: "(+10:00) Hobart" },
    { key: "Australia/Melbourne", name: "(+10:00) Melbourne" },
    { key: "Pacific/Port_Moresby", name: "(+10:00) Port Moresby" },
    { key: "Australia/Sydney", name: "(+10:00) Sydney" },
    { key: "Asia/Yakutsk", name: "(+10:00) Yakutsk" },
    { key: "Asia/Vladivostok", name: "(+11:00) Vladivostok" },
    { key: "Pacific/Auckland", name: "(+12:00) Auckland" },
    { key: "Pacific/Fiji", name: "(+12:00) Fiji" },
    { key: "Pacific/Kwajalein", name: "(+12:00) International Date Line West" },
    { key: "Asia/Kamchatka", name: "(+12:00) Kamchatka" },
    { key: "Asia/Magadan", name: "(+12:00) Magadan" },
    { key: "Pacific/Fiji", name: "(+12:00) Marshall Is." },
    { key: "Asia/Magadan", name: "(+12:00) New Caledonia" },
    { key: "Asia/Magadan", name: "(+12:00) Solomon Is." },
    { key: "Pacific/Auckland", name: "(+12:00) Wellington" },
    { key: "Pacific/Tongatapu", name: "(+13:00) Nuku'alofa" }
];
